var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuelLisbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_Icons/Map/Fuel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uD83D\\uDCCFCirculation-Rules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circulation-Rules_MODAL-LISBON_-2",
    transform: "translate(-940.000000, -263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Icons/Map/Fuel",
    transform: "translate(940.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#020078",
    strokeWidth: 0.833333333,
    fill: "#F3F5FD",
    x: 0.416666667,
    y: 0.416666667,
    width: 25.1666667,
    height: 25.1666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "fuel",
    transform: "translate(1.333333, 1.332508)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18.3300339 L14.0002062,18.3300339 C14.4603296,18.3300339 14.8333333,18.7030376 14.8333333,19.163161 C14.8333333,19.6232844 14.4603296,19.9962881 14.0002062,19.9962881 L4.83312712,19.9962881 C4.37300372,19.9962881 4,19.6232844 4,19.163161 C4,18.7030376 4.37300372,18.3300339 4.83312712,18.3300339 L4.83333333,18.3300339 L4.83333333,18.3300339 L4.83333333,5.83312712 C4.83333333,5.37300372 5.20642938,5 5.66666667,5 L13.1666667,5 C13.626904,5 14,5.37300372 14,5.83312712 L14,12.498144 L15.6666667,12.498144 C16.5871412,12.498144 17.3333333,13.2441515 17.3333333,14.1643983 L17.3333333,17.4969067 C17.3333333,17.9570301 17.7064294,18.3300339 18.1666667,18.3300339 C18.626904,18.3300339 19,17.9570301 19,17.4969067 L19,11.6650169 L17.3333333,11.6650169 C16.873096,11.6650169 16.5,11.2920132 16.5,10.8318898 L16.5,7.84429597 L15.7083333,7.05282521 C15.3830261,6.72759847 15.3829608,6.20023648 15.7081876,5.87492923 C15.7082362,5.87488064 15.7082847,5.87483205 15.7083333,5.87478347 C16.0337447,5.54945265 16.5612553,5.54945265 16.8866667,5.87478347 L20.4225,9.40974182 L20.4225,9.40974182 C20.5790247,9.56579095 20.666895,9.77776694 20.6666671,9.9987627 L20.6666671,17.4969067 C20.6666671,18.8772769 19.5473785,19.9962881 18.1666667,19.9962881 C16.7859548,19.9962881 15.6666667,18.8772769 15.6666667,17.4969067 L15.6666667,14.1643983 L14,14.1643983 L14,18.3300339 Z M6.5,18.3300339 L12.3333333,18.3300339 L12.3333333,13.3312712 L6.5,13.3312712 L6.5,18.3300339 Z M6.5,6.66625423 L6.5,11.6650169 L12.3333333,11.6650169 L12.3333333,6.66625423 L6.5,6.66625423 Z",
    id: "Shape",
    fill: "#020078",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelLisbon);
export default __webpack_public_path__ + "static/media/fuel_lisbon.97caa8b9053fd41321a42655c4e7ad42.svg";
export { ForwardRef as ReactComponent };